import React from 'react';
import styled from 'styled-components';

interface HeaderProps {
    children: React.ReactNode;
    highlightText?: string;
    highlightColor?: string;
}

const StyledHeader = styled.h1`
    font-size: ${({ theme }) => theme.fontSizes.header};
    font-weight: ${({ theme }) => theme.fontWeights.bold};
    line-height: 1.2;
    margin-bottom: ${({ theme }) => theme.spacing.xl};
    
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        font-size: ${({ theme }) => theme.fontSizes.headerMobile};
    }
`;

const Highlight = styled.span<{ $color?: string }>`
    color: ${({ $color, theme }) => $color || theme.colors.primary};
`;

export const Header: React.FC<HeaderProps> = ({ children, highlightText, highlightColor }) => {
    if (highlightText && typeof children === 'string') {
        const parts = children.split(highlightText);
        return (
            <StyledHeader>
                {parts[0]}
                <Highlight $color={highlightColor}>{highlightText}</Highlight>
                {parts[1]}
            </StyledHeader>
        );
    }
    
    return <StyledHeader>{children}</StyledHeader>;
};
